import { BaseIdCodeModel } from 'common-shared';
import { CostPriceComponentSurchargeViewModel } from './cost-price-component-surcharge-view.model';
import {Type} from 'class-transformer';

export class CostPriceComponentViewModel extends BaseIdCodeModel {
  Price: number;
  Description: string;
  TypeClv: string;

  @Type(() => CostPriceComponentSurchargeViewModel)
  CostPriceComponentSurcharges: Array<CostPriceComponentSurchargeViewModel> = [];

  constructor() {
    super();
  }

  static CreateDefault(init?: Partial<CostPriceComponentViewModel>) {
    return Object.assign(new CostPriceComponentViewModel(), {} as CostPriceComponentViewModel, init);
  }
}
